import {ref} from "@vue/reactivity";

const msgModalIsOpen = ref(false);
const modalMsg = ref("No message.");

const showModalMsg = (msg) => {
    modalMsg.value = msg;
    msgModalIsOpen.value = true;
}

export {
    msgModalIsOpen,
    modalMsg,
    showModalMsg
}